<template>
  <el-form ref="IForm" :inline="true" :model="formData" :rules="rules" :size="pageSize"
           style="padding:0 10px 10px 10px">
    <div class="rootBox" :style="styles">
      <div class="leftBox">
        <div class="headerBox" v-show="showBaseInfo">
          <div class="header-user-info">
            <el-form-item label="院校" prop="deptName">
              <el-input :value="formData.deptName" disabled></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="formData.name" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="userName">
              <el-input :value="formData.userName" disabled></el-input>
            </el-form-item>
            <el-form-item label="身份" prop="userTypeStr">
              <el-input :value="formData.userTypeStr" disabled></el-input>
            </el-form-item>
            <el-form-item v-if="organizeList && organizeList.length" label="组织" prop="firstStructId">
              <el-select v-model="formData.firstStructId" clearable placeholder="请选择组织">
                <el-option
                  v-for="item in organizeList"
                  :key="item.structId"
                  :label="item.structName"
                  :value="item.structId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else label="组织" prop="firstStructName">
              <el-input :value="formData.firstStructName" disabled></el-input>
            </el-form-item>
          </div>
          <div class="headerBg" ref="headerBg" @click="selectImage"
               :style="getHeadBackground()">
            <input type="file" @change="headerBgChange($event)" style="display: none" ref="sectionImg"
                   accept=".png, .jpg, .jpeg"></input>
          </div>
        </div>
        <div class="mainBox">
          <el-form-item label="角色" prop="roleIdList" v-if="roleList && roleList.length">
            <el-select v-model="formData.roleIdList" clearable placeholder="请选择角色" multiple filterable>
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="formData.sex">
              <el-option label="男" :value="0"></el-option>
              <el-option label="女" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生年月" prop="birthdayDate">
            <el-date-picker
              v-model="formData.birthdayDate" type="date" placeholder="选择日期" :picker-options="birthdayPicker">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证件类型" prop="cardType">
            <el-select v-model="formData.cardType">
              <el-option label="身份证" :value="0"></el-option>
              <el-option label="其他" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号" prop="idCard">
            <el-input v-model="formData.idCard" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="formData.email" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="微信" prop="weChat">
            <el-input v-model="formData.weChat" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="QQ" prop="penguin">
            <el-input v-model="formData.penguin" @input="toInteger(formData,'penguin')" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="省份" prop="provinceId">
            <el-select v-model="formData.provinceId">
              <el-option v-for="item in provinces" :label="item.name" :value="item.id"
                         :key="item.id+item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通讯地址" prop="postalAddress">
            <el-input v-model="formData.postalAddress" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="工作单位" prop="workPlace">
            <el-input v-model="formData.workPlace" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="department">
            <el-input v-model="formData.department" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="专业方向" prop="majorField">
            <el-input v-model="formData.majorField" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="professionalTitle">
            <el-input v-model="formData.professionalTitle" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input v-model="formData.position" placeholder="请输入..."></el-input>
          </el-form-item>
          <!--          <el-form-item label="工作编号" prop="jobNumber">-->
          <!--            <el-input :value="formData.jobNumber" placeholder="请输入..." disabled></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="银行卡号" prop="bankAccount">
            <el-input v-model="formData.bankAccount" @input="toInteger(formData,'bankAccount')"
                      placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="bankDeposit">
            <el-input v-model="formData.bankDeposit" placeholder="请输入..."></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="rightBox">
        <div class="addBox" :style="getAddBackground(item)" v-for="item in achievements" @click="editInfo(item)":key="item.key">
          <el-form-item :prop="item.key" v-show="false"></el-form-item>
        </div>
      </div>
    </div>
    <el-dialog
      :title="currentItem.title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :modal="dialogModal"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :destroy-on-close="true"
    >
      <wjl-editor v-model="formData[currentItem.key]" :only-key="onlyKey" maxHeight="400px" height="400px"></wjl-editor>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="ok">确 定</el-button>
     </span>
    </el-dialog>
  </el-form>
</template>
<script>
import wjlEditor from '@/components/wjlEditor/index.vue'
import {queryProvince} from "@/api/PostUrl";
import {uploadImageDefaultForMap} from "@/api/filePostApi";
import {isEmail, isIdCard} from "@/libs/ValidateUtils";

export default {
  title: '教师信息',
  name: "teacherInfo",
  components: {
    wjlEditor
  },
  props: {
    dialogModal: {
      type: Boolean,
      default: true
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    showBaseInfo: {
      type: [Boolean, Number, String],
      default: true
    },
    roleList: {
      type: Array,
      default: () => []
    },
    organizeList: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    value: {
      handler(newVal) {
        Object.assign(this.formData, newVal);
        this.setFirstStructName()
      },
      immediate: true
    }
  },
  computed: {
    getAddBackground() {
      return function (item) {
        return {backgroundImage: `url(${item.img})`}
      }
    },
    getHeadBackground() {
      return function () {
        let img = null
        if (this.formData.prsonalPhotos) {
          img = `url(${this.formData.prsonalPhotos})`
        } else {
          if (this._$isInteger(this.formData.sex)) {
            img = `url(${this.headerImages[this.formData.sex].img})`
          }
        }
        return {backgroundImage: img}
      }
    }
  },
  data() {
    return {
      pageSize: null,
      birthdayPicker: {
        disabledDate: (time) => time.getTime() > Date.now() - 8.64e7
      },
      toInteger: this._$toInteger,
      currentItem: {},
      currentContent: '',
      onlyKey: 0,
      dialogVisible: false,
      provinces: [],
      headerImage: '',
      headerImages: [
        {name: 'icon_man', img: ''},
        {name: 'icon_girl', img: ''},
      ],
      achievements: [
        {
          key: 'personalIntroduction',
          title: '个人介绍',
          name: '_grjs',
          img: ''
        },
        {
          key: 'personalGlory',
          title: '个人荣誉',
          name: '_grry',
          img: ''
        },
        {
          key: 'winningAchievement',
          title: '获奖成果',
          name: '_hjcg',
          img: ''
        },
        {
          key: 'teachingProject',
          title: '教学项目',
          name: '_jxxm',
          img: ''
        },
        {
          key: 'scientificResearchTask',
          title: '科研课题',
          name: '_kykt',
          img: ''
        },
        {
          key: 'textbookEditor',
          title: '主编教材',
          name: '_zbjc',
          img: ''
        },
        {
          key: 'remark',
          title: '备注',
          name: '_txbz',
          img: ''
        },
      ],
      formData: {
        strRoleIds:null,
        firstStructId: '',//组织ID
        roleIdList: null,//角色列表
        cardType: '',//证件类型
        city: '',//城市
        deptName: '',//院校
        educationalLevel: '',//教育程度
        firstStructName: '',//第一个组织名称
        idCard: '',//证件号
        mobile: '',//电话
        name: '',//姓名
        profession: '',//职业
        province: '',//省份
        schoolDate: '',
        secondStructName: '',//第二个组织名称
        // studentNumberOrjobNumber: '',//学生编号或工作编号
        // jobNumber: '',//工作编号
        teachingClass: '',//教学班
        userName: '',//账号
        userType: '',//用户类型
        userTypeStr: '',//身份
        /*=====================================上面是教师基本信息，下面是教师拓展信息==============================================*/
        sex: '',//性别
        birthdayDate: '',//出生年月
        email: '',//邮箱
        weChat: '',//微信
        penguin: '',//QQ
        provinceId: '',//省份id
        postalAddress: '',//通讯地址
        workPlace: '',//工作单位
        department: '',//部门
        majorField: '',//专业方向
        professionalTitle: '',//职称
        position: '',//职位
        bankAccount: '',//银行账户
        bankDeposit: '',//开户行
        prsonalPhotos: '',//个人照片

        personalIntroduction: '',//个人介绍
        personalGlory: '',//个人荣誉
        winningAchievement: '',//获奖成果
        teachingProject: '',//教学项目
        scientificResearchTask: '',//科研课题
        textbookEditor: '',//主编教材
        remark: '',//备注

        userId: '',//用户ID
      },
      base64Key:{
        personalIntroduction: '',//个人介绍
        personalGlory: '',//个人荣誉
        winningAchievement: '',//获奖成果
        teachingProject: '',//教学项目
        scientificResearchTask: '',//科研课题
        textbookEditor: '',//主编教材
        remark: '',//备注
      },
      rules: {
        name: this._$validatorNoEmpty('姓名'),
        cardType: this._$validatorNoEmpty('证件类型'),
        firstStructId: this._$validatorNoEmpty('组织'),
        roleIdList: this._$validatorNoEmptyForCall('角色',()=>(this.formData.roleIdList && this.formData.roleIdList.length)),
        bankAccount: this._$validatorMinOfMaxLength('银行卡', 16, 19, false),
        email: this._$validatorToCall('邮箱格式不正确', value => !value || isEmail(value)),
        idCard: this._$validatorConcat(this._$validator('证件号'),
          this._$validatorToCall('身份证格式不正确',
            value => ((String(this.formData.cardType) === '0') && isIdCard(value)) || (String(this.formData.cardType) !== '0')))
      }
    }
  },
  created() {
    this.setImage()
  },
  mounted() {
    this.initDataFun()
    window.onresize = (e) => {
      const rootBox = document.body
      if (rootBox.offsetHeight <= 720) {
        this.pageSize = 'mini'
      } else {
        this.pageSize = null
      }
      // console.log(rootBox.offsetWidth,rootBox.offsetHeight)
    }
  },
  methods: {
    initDataFun() {
      this.formData.roleIdList = this.formData.strRoleIds
      this.queryProvince()
    },
    async queryProvince() {
      this.provinces = await this.$apiPost.httpGetForMap(queryProvince)
    },
    setImage() {
      this.achievements.forEach(item => {
        item.img = require(`../../../../../../src/assets/image/icon/${item.name}.png`)
      })
      this.headerImages.forEach(item => {
        item.img = require(`../../../../../../src/assets/image/icon/${item.name}.png`)
      })
    },
    setFirstStructName() {
      if (!this.formData.firstStructName) {
        this.formData.firstStructName = '全机构'
      }
      this.handlerDataFromBase64(this.formData)
    },
    editInfo(item) {
      this.$set(this, 'currentItem', item)
      this.$set(this, 'dialogVisible', true)
      this.$set(this, 'currentContent', this.formData[item.key])
      this.$nextTick(() => ++this.onlyKey)
    },
    selectImage() {
      this.$refs.sectionImg.click()
    },
    headerBgChange(ev) {
      if (ev.target.files) {
        const file = ev.target.files[0]
        let fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = (data) => {
          // this.$refs.headerBg.style.backgroundImage = `url(${data.target.result})`;
          const formData = new FormData()
          formData.append('file', file)
          uploadImageDefaultForMap(formData).then(data => this.formData.prsonalPhotos = data['imagePath'])//个人照片
        }
      }
    },
    cancel() {
      this.dialogVisible = false
      this.formData[this.currentItem.key] = this.currentContent
    },
    ok() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
      //重置数据
      this.cancel()
    },
    submitForm() {
      let formData = JSON.parse(JSON.stringify(this.formData))
      this.handlerDataToBase64(formData)
      const promise = new Promise((resolve, reject) => this.$refs['IForm'].validate(valid => valid ? resolve(formData) : reject(valid)))
      promise.catch(_ => console.log('校验失败'))
      return promise
    },
    resetForm() {
      this.$refs['IForm'].resetFields();
    },
    handlerDataToBase64(formData) {
      Object.keys(this.base64Key).forEach(key => formData[key] = window.btoa(encodeURIComponent(formData[key] || '')))
    },
    handlerDataFromBase64(formData) {
      try{
        Object.keys(this.base64Key).forEach(key => formData[key] = decodeURIComponent(window.atob(formData[key] || '')))
      }catch (e) {}
    }
  }
}
</script>

<style scoped lang="scss">
.rootBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  overflow-y: auto;
}

.rootBox > div {
  flex: 0 1 50%;
}


.leftBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  //border-right: 1px solid #c0c4cc;
  box-sizing: border-box;
  min-width: 660px;
  padding-right: 20px;
  /deep/ .el-form-item {
    width: 100%;

    .el-form-item__content {
      width: calc(100% - 100px);
    }

    .el-input {
      width: 100%;
    }

    .el-select {
      width: 100%;
    }
  }
}


.headerBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;

  .header-user-info {
    flex: 1;
    display: grid;
    height: 90%;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
  }

  .header-user-info .el-form-item:nth-child(1) {
    grid-column: 1/span 2;
  }

  .headerBg {
    height: 180px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    border-radius: 8px;
    flex-basis: 150px;
    background: url(../../../../../../src/assets/image/icon/icon_head.png) no-repeat center;
    background-size: 101% 101%;
    position: relative;
    cursor: pointer;

    &::before {
      content: '';
      transform: scale(0);
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: #DCDFE665;
      border-radius: 8px;
      transition: all 0.5s linear;
    }

    &:hover::before {
      content: '';
      display: flex;
      justify-content: center;
      align-items: center;
      content: url(../../../../../../src/assets/image/icon/icon_edit.png);
      transform: scale(1);
    }

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      bottom: 10px;
      transform: scale(0);
      transition: all 0.5s linear;
      color: #5c6065;
      font-size: 12px;
    }

    &:hover::after {
      content: '建议150x180像素';
      display: flex;
      justify-content: center;
      align-items: end;
      transform: scale(1);
    }
  }

}

.mainBox {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-content: start;
  text-align: right;
  padding-top: 30px;
  box-sizing: border-box;
}

.rightBox {
  //display: grid;
  //grid-template-columns: repeat(3,1fr);
  //grid-template-rows: auto;
  //align-content: start;
  //text-align: center;
  //gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-items: flex-start;
  align-content: start;
  box-sizing: border-box;
  min-width: 660px;
  /deep/ .el-form-item {
    width: 100%;

    .el-form-item__content {
      width: 100%;
      height: 100%;
    }

    .el-input {
      width: 100%;
    }

    .el-select {
      width: 100%;
    }
  }
}

.addBox {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(100vw * 0.14);
  height: calc(100vw * 0.08);
  min-width: 33%;
  max-width: 33%;
  min-height: 140px;
  position: relative;
  border-radius: 8px;
  transition: all .5s linear;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  cursor: pointer;
  transform: scale(0.9);
  opacity: 0.8;

  p {
    width: 100%;
    position: absolute;
    bottom: 0;
    text-align: center;
  }
}

.addBox:hover {
  transform: translateY(-2%) scale(1);
  box-shadow: 0 5px 15px rgb(213, 215, 220);
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/components/teacherInfo.vue